(() => {
  const init = root => {
    root.querySelectorAll('[data-suite-console]').forEach(console => {
      if (console.dataset.ready) return;
      const tabs = [...console.querySelectorAll('[data-suite-tab]')];
      const panels = [...console.querySelectorAll('[data-suite-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;});
        panels.forEach((panel, i) => {panel.hidden = i !== index;});
        console.style.setProperty('--active-accent', tabs[index].dataset.accent);
        if (focus) tabs[index].focus();
      };
      console.dataset.ready = 'true';
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', event => {if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;event.preventDefault();activate(i);});
        tab.addEventListener('keydown', event => {
          let next = i;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === ' ') {event.preventDefault();activate(i);return;}
          else return;
          event.preventDefault();activate(next, true);
        });
      });
      console.querySelector('[data-suite-tabs]').setAttribute('role', 'tablist');
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      activate(0);
      console.addEventListener('shopify:block:select', event => {
        const index = tabs.findIndex(tab => tab.dataset.blockId === event.detail.blockId);
        if (index >= 0) activate(index);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
